/**
 * Version 0.110
 *
 * Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
 * Copyright 2016 - 2026.
 *
 * !Changelog
 * 
 * 2026
 * 08-02-2026
 * - [CHANGE] images.preload() is now checking if the function exists before calling it.
 * 2018
 * 	17-10-2018
 * 	- [BORN] This class is born. Hooray!
 *
 * !Usage
 *
 * 	-
 *
 * !Wishlist
 *
 * 	none
 */

var specific_interactions_firstload = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function () {

		/**
		 * Trigger: modal and popup preloader
		 */
		if (typeof images !== 'undefined' && typeof images.preload === 'function') {
			images.preload();
		}
		modal.onready();
		popup.onready();
		form.onready();
		if (pollConnection === 1) { poll_connection.onready(); }

		/**
		 * Trigger: onready classes
		 */
		specific_mobilemenu.onready();

		/**
		 * Visitor recording
		 */
		//specific_visitor_recording.onready();

		/**
		 * Trigger: onready specific classes
		 */
		// none yet

		/**
		 * Scroll 2 data-to
		 */
		$(document).on('click', '.js-scroll', function (e) {

			e.preventDefault();
			var target = $(this).data('to');
			
			if (target) {
				var offset = $(target).offset().top;
				$('html, body').animate({
					scrollTop: offset
				}, 500);
			}
			
		});

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none

}).apply(specific_interactions_firstload); 
